import * as React from "react";
import type { SVGProps } from "react";
const SvgDisplayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.984 4.5a1 1 0 0 1 1-1h18.032a1 1 0 1 1 0 2H2.984a1 1 0 0 1-1-1ZM1.984 11.325a1 1 0 0 1 1-1h5.295a1 1 0 1 1 0 2H2.984a1 1 0 0 1-1-1ZM2.984 17.649a1 1 0 1 0 0 2h5.295a1 1 0 1 0 0-2H2.984ZM16.333 16.458a1.379 1.379 0 1 0 0-2.757 1.379 1.379 0 0 0 0 2.757Z"
    />
    <path
      fill="currentColor"
      d="M10.7 14.48a1.53 1.53 0 0 0 0 1.2 5.98 5.98 0 0 0 11.005.001 1.53 1.53 0 0 0 0-1.2 5.98 5.98 0 0 0-11.005 0Zm1.924.6a3.98 3.98 0 0 1 7.157.001 3.979 3.979 0 0 1-7.157 0Z"
    />
  </svg>
);
export default SvgDisplayIcon;
